<button class="scroll-to-top" [class.show]="showScrollButton" (click)="scrollToTop()" [title]="'scrollToTop' | translate">
    <i class="ti ti-chevron-up"></i>
    <div class="scroll-progress"></div>
</button>
